export class OptimizedPromptModalController {
    static $inject = ['close', 'originalInstructions', 'optimizedInstructions'];
    constructor(close, originalInstructions, optimizedInstructions) {
        this.close = close;
        this.originalInstructions = originalInstructions;
        this.optimizedInstructions = optimizedInstructions;
    }
    // Method unused, but kept for potential future use
    async _confirm() {
        this.close(true);
    }
    async _cancel() {
        this.close(false);
    }
}
